






























import Vue from "vue";
import formatDate from "../../helpers/formatDate";
import formatCurrency from "../../helpers/formatCurrency";
const formatScheduleDate = function(TimeVal) {
  let scheduleTime = "";
  let scheduleDate = "";

  scheduleTime = `${(TimeVal.hours < 10
    ? `${TimeVal.hours}`
    : `0${Math.abs(TimeVal.hours - 12)}`) +
    ":" +
    (TimeVal.minutes < 10 ? `0${TimeVal.minutes}` : TimeVal.minutes) +
    `:00 ${TimeVal.hours < 10 ? "am" : "pm"}`}`;

  scheduleDate =
    TimeVal.year +
    "-" +
    (TimeVal.month < 10 ? `0${TimeVal.month}` : TimeVal.month) +
    "-" +
    (TimeVal.day < 10 ? `0${TimeVal.day}` : TimeVal.day);

  return {
    scheduleDate,
    scheduleTime
  };
};
export default Vue.extend({
  name: "MessageRow",
  props: ["item"],
  setup(props, context: any): any {
    return {
      formatDate,
      formatScheduleDate,
      formatCurrency,
      store: context.root.$store.state.store
    };
  }
});
